import "../CSS/ticket.css";
import React, { useRef, useEffect, useState, Fragment } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { useLocation } from "react-router-dom";
import axios from "axios";

function Ticket(props) {
  const {
    salon,
    nombre,
    fecha,
    nombreParticipante,
    asientos,
    id,
    idTicket,
    handleConvert,
	fechaCompra,

  } = props;
  const [url, setUrl] = useState("");
  const [shortUrl, setShortUrl] = useState("");

  const downloadQRCode = (e) => {
    e.preventDefault();
    setUrl("");
  };

  const qrCodeEncoder = (e) => {
    setUrl(e.target.value);
  };
  const location = useLocation();
  const handleShortenUrl = async () => {
    try {
      const response = await axios.get(
        `https://tinyurl.com/api-create.php?url=${encodeURIComponent(
          window.location.href
        )}`
      );
      console.log("link corto " + response.data.replace("https://", ""));
      setShortUrl(response.data.replace("https://", ""));
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const qrcode = (
    <QRCodeCanvas
      style={{ marginTop: "10px" }}
      id="qrCode"
      value={`${shortUrl}`}
      size={100}
      bgColor={"#ffffff"}
      level={"H"}
    />
  );
  useEffect(() => {
    handleShortenUrl();
  }, []);
  useEffect(() => {
    handleConvert();
  }, [shortUrl]);
  return (
    <div className="cardWrap">
      <div className="card cardLeft">
        <div className="cabecera">
          <img className="logo" src={require("../img/logo_cip.png")} />
          <h1 className="titulo-cabecera">
            <span>COLEGIOS DE INGENIEROS DEL PERU</span>
            <br />
            <span>CONSEJO DEPARTAMENTAL AREQUIPA</span>
            <br />
          </h1>
        </div>

        <div className="title">
          <h2>{nombre}</h2>
          <span>Evento</span>
        </div>
        <div className="title">
          <h2>{salon}</h2>
          <span>Lugar</span>
        </div>
        <div className="nameTicket">
          <h2>{nombreParticipante}</h2>
          <span>Nombre Del Participante</span>
        </div>

        <div className="seat">
          <h2>{fecha}</h2>
          <span>Fecha y hora del evento</span>
        </div>
      </div>
      <div className="card cardRight">
        <div className="card-eye">
          <h1 className="titulo-cabecera">
            <span>fecha de compra</span>
            <br />
            <span>{fechaCompra.split(",")[0]}</span>
            <br />
          </h1>
        </div>
        <div className="card-eye">
          <div>{qrcode}</div>
        </div>
        <div className="number">
          <h3 className="numberAsientos">
            {asientos.split(",").sort().toString()}
          </h3>
          <span> {asientos.split(",").length} Asientos</span>
        </div>
      </div>
    </div>
  );
}

export default Ticket;
